import SectionGames from './SectionGames';

export default SectionGames;
